<template lang="pug">
.bq-sidenav(:class="{ mobile: isMobile }")
    .bq-sidenav-top
        nav.bq-nav

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}`"
                :class="{ active: route.name === 'dashboard' }"
                @click="emit('closeMobileMenu')"
            )
                span Settings
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") settings

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/records`"
                :class="{ active: route.name === 'records' }"
                @click="emit('closeMobileMenu')"
            )
                span Database
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") database

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/users`"
                :class="{ active: route.name === 'users' }"
                @click="emit('closeMobileMenu')"
            )
                span Users
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") group

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/clientsecret`"
                :class="{ active: route.name === 'clientsecret' }"
                @click="emit('closeMobileMenu')"
            )
                span Secret Keys
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") key

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/openid`"
                :class="{ active: route.name === 'openid' }"
                @click="emit('closeMobileMenu')"
            )
                span Open ID
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") fingerprint

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/tickets`"
                :class="{ active: route.name === 'tickets' }"
                @click="emit('closeMobileMenu')"
            )
                span Tickets
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") confirmation_number

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/mail`"
                :class="{ active: route.name === 'mail' }"
                @click="emit('closeMobileMenu')"
            )
                span Automated Emails
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") mail

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/newsletter`"
                :class="{ active: route.name === 'newsletter' }"
                @click="emit('closeMobileMenu')"
            )
                span Newsletters
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") newspaper

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/hosting`"
                :class="{ active: route.name === 'hosting' }"
                @click="emit('closeMobileMenu')"
            )
                span Web Hosting
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") public

</template>

<script setup>
import { useRoute } from "vue-router";
import { onMounted, onUnmounted, ref } from "vue";
import { currentService } from "@/views/project-list";

const route = useRoute();

const emit = defineEmits(["closeMobileMenu"]);
const isMobile = ref(false);

const checkMobile = () => {
    isMobile.value = window.innerWidth <= 800;
};

onMounted(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile);
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-sidenav {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    font-family: @mono;
    color: @ink;
    background: @paper;

    &.mobile {
        height: auto;
        border-right: none;
        border-bottom: 1px solid @line;

        .bq-sidenav-bottom {
            display: none;
        }
    }
}

.bq-sidenav-top {
    padding-top: 3rem;
}

// Layout only. Colour, underline and hover come from the shared .bq-cta-link;
// the arrow is a .bq-arrow so the underline stops before it.
.bq-back-link {
    display: inline-block;
    margin: 0 1.5rem 1rem;
    font-size: 0.82rem;
}

.bq-service-header {
    padding: 2rem 1.5rem 1.5rem;
    text-align: left;
}

.bq-service-name {
    margin-top: 0.5rem;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bq-nav {
    display: flex;
    flex-direction: column;
    // padding: 0.5rem 0;
}

.bq-nav-item {
    /* Label + icon on one row. Desktop pushes the icon to the RIGHT edge
       (space-between); the mobile pulldown flips to icon-on-the-LEFT via
       row-reverse below - markup order stays label-then-icon in both. */
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.65rem 1.5rem;
    font-size: 0.85rem;
    color: @ink;
    text-decoration: none;
    transition: color 0.1s, text-shadow 0.1s;
    border-right: 2px solid transparent;

    /* text-shadow inherits, so the row carries it and the glyph opts back out:
       a hard 2px offset on a material icon reads as a double image rather than
       a lift. */
    .bq-nav-icon {
        text-shadow: none;
    }

    &:hover {
        color: @pink;
        text-shadow: var(--bq-text-shadow);
    }

    &.active {
        color: @pink;
        font-weight: 600;
        border-right-color: @pink;
        background: @pink-bg;
        text-shadow: var(--bq-text-shadow);
    }
}

.bq-sidenav-bottom {
    padding: 1.5rem;
    // border-top: 1px solid @line;
}

.bq-upgrade-link {
    display: block;
    text-align: center;
    padding: 0.6rem 1rem;
    border: 1px solid @ink;
    color: @ink;
    font-family: @mono;
    font-size: 0.82rem;
    text-decoration: none;
}

.bq-nav-icon {
    font-size: 1.05rem;
    opacity: 0.65;
}

/* Mobile pulldown: icon leads the label. */
.bq-sidenav.mobile .bq-nav-item {
    flex-direction: row-reverse;
    justify-content: flex-end;
}
</style>
